export default __webpack_public_path__ + "static/media/girl6.96165ab5.svg";